export default __webpack_public_path__ + "static/media/event-wall-2.a9214e17.jpg";